import { DivisioFinalis } from '../bars/DivisioFinalis';
import { DivisioMaior } from '../bars/DivisioMaior';
import { DivisioMinima } from '../bars/DivisioMinima';
import { DivisioMinimis } from '../bars/DivisioMinimis';
import { DivisioMinor } from '../bars/DivisioMinor';
import { Clef } from '../clefs';
import { Space } from '../elements/Space';
import { ChantLayoutElement } from '../layout/ChantLayoutElement';
import { Custos } from '../signs';
import { GlyphVisualizer } from './GlyphVisualizer';
import { Mora } from './Mora';

export function isSign(e: ChantLayoutElement) {
  return e instanceof Mora;
}

export function isBarVisualizer(e: ChantLayoutElement) {
  return e instanceof DivisioFinalis || e instanceof DivisioMinima || e instanceof DivisioMinor ||
    e instanceof DivisioMinimis || e instanceof DivisioMaior;
}

export function isGlyphVisualizerOrSpaceOrBar(e: ChantLayoutElement) {
  return e instanceof GlyphVisualizer || e instanceof Space || e instanceof Clef ||
    e instanceof Custos || isBarVisualizer(e);
}
